// extracted by mini-css-extract-plugin
export default {"container":"formNotice_container__cpjw-"};